import { AbstractControl } from '@angular/forms';
import { Location } from '@geneplanet/ngx-utils/src/lib/localization';
import { CategoryReport } from 'src/app/core/interfaces';

export class Util {
  static isMale(gender: string): boolean {
    return gender.toUpperCase() === 'MALE';
  }

  static preloadImages(imageUrls: string[]) {
    const images = [];

    for (let i = 0; i < imageUrls.length; i++) {
      images[i] = new Image();
      images[i].src = imageUrls[i];
    }
  }

  static localizeEnvironmentPage(location: Location, page: string) {
    const search = 'geneplanet.com';
    const index = page.search(search);
    if (index > -1) {
      return [
        page.slice(0, index + search.length),
        '/' + location.code,
        page.slice(index + search.length),
      ].join('');
    }
    return page;
  }

  static sortReports(reports: CategoryReport[], sortedProductIds: string[]) {
    return reports.sort((a, b) =>
      sortedProductIds.indexOf(a.productId) >
      sortedProductIds.indexOf(b.productId)
        ? 1
        : -1
    );
  }
}

/**
 * This will remove error from FormControl by mutation and leaving errors of existing as they are.
 * @param control FormControl
 * @param errorName 
 */
export const removeFormControlError = (
  control: AbstractControl,
  errorName: string
) => {
  if (control?.errors && control?.errors[errorName]) {
    delete control.errors[errorName];
    if (Object.keys(control.errors).length === 0) {
      control.setErrors(null);
    }
  }
};
